<mat-sidenav-container >
    <mat-sidenav #drawer class="sidenav primary-background-element" fixedInViewport role="navigation" mode="over"
        opened="false">
        <mat-nav-list>
            <br />
            <a #home (mouseenter)="deselectOther(home)" (mouseleave)="returnSelection(home)"
                mat-list-item routerLink="/" [routerLinkActiveOptions]="{ exact: true }"
                class="accent-hover-element primary-text-element" routerLinkActive='accent-background-element selected'>
                <span translate>Home</span>
            </a>
            <a #converter (mouseenter)="deselectOther(converter)"
                (mouseleave)="returnSelection(converter)" mat-list-item routerLink="/shopManager"
                [routerLinkActiveOptions]="{ exact: true }" class="accent-hover-element primary-text-element"
                routerLinkActive='accent-background-element selected'>
                <span translate>Shop Manager</span>
            </a>
            <a #converter (mouseenter)="deselectOther(converter)"
                (mouseleave)="returnSelection(converter)" mat-list-item routerLink="/patientManager"
                [routerLinkActiveOptions]="{ exact: true }" class="accent-hover-element primary-text-element"
                routerLinkActive='accent-background-element selected'>
                <span translate>Patient Manager</span>
            </a>
        </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content class="background">
        <mat-toolbar color="primary" class="toolbar row">
            <button type="button" aria-label="Toggle sidenav" class="flex-child-wrapper" mat-icon-button
                (click)="drawer.toggle()">
                <mat-icon class="secondary-contrast-icon" aria-label="Side nav toggle icon">menu</mat-icon>
            </button>
            <img [src]="getLogoSrc()">
            <div class="spacer"></div>
            <app-avatar [fullName]="getUserName()" [fillColor]="true" [showName]='true' [diameter]="30"></app-avatar>
            <button mat-raised-button color="accent" id="logout-btn" (click)="logout()"><mat-icon class='primary-icon' svgIcon="logout"></mat-icon>Logout</button>
        </mat-toolbar>
        <div class="container ">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>